import { requireDashboardOrigin } from "@api/auth/dashboardOriginGuard"
import { serverRouteConfig } from "@lib/serverRouteConfig"
import { createFileRoute } from "@tanstack/react-router"
import * as z from "zod"

const passwordResetConfirmInputSchema = z.object({
  token: z.string().min(1).max(4096),
  password: z.string().min(8).max(128).regex(/[a-z]/).regex(/[A-Z]/).regex(/[0-9]/),
})

export const Route = createFileRoute("/api/dashboard/auth/password-reset/confirm")(
  serverRouteConfig({
    server: {
      handlers: {
        POST: async ({ request }) => {
          const originError = requireDashboardOrigin(request)
          if (originError) return originError

          try {
            const input = passwordResetConfirmInputSchema.parse(await request.json())
            const { confirmDashboardPasswordReset } = await import("@api/auth/dashboardPasswordResetApi")
            await confirmDashboardPasswordReset(input)
            return Response.json({ reset: true })
          } catch (error) {
            return Response.json(
              {
                error: error instanceof Error ? error.message : "Could not reset password.",
              },
              { status: 400 }
            )
          }
        },
      },
    },
  })
)
